// extracted by mini-css-extract-plugin
export var cardsCarousel = "CardsCarousel-module--cards-carousel--fUtrg";
export var cardsCarouselSlide = "CardsCarousel-module--cards-carousel-slide---pEhf";
export var cardsCarouselSlideSelected = "CardsCarousel-module--cards-carousel-slide--selected--23-3B";
export var cardsCarouselSelected = "CardsCarousel-module--cards-carousel-selected--389Hm";